import YourProfile from './YourProfile.component';

export default YourProfile;
